
import Vue from 'vue'
import { Prop, Component, Watch } from 'vue-property-decorator'
import { AgencyUser, UserCommission } from '../../global/models'

@Component
export default class UserForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  private readonly value!: Partial<AgencyUser>

  @Prop({ type: Boolean, default: false })
  private readonly edit!: boolean

  @Prop({ type: Object, default: () => ({}) })
  private readonly commission!: Partial<UserCommission>

  account: Partial<AgencyUser> = {}

  brokerPercentage: undefined | number = 0

  mounted() {
    if(this.commission) {
      this.brokerPercentage = this.commission.brokerPercentage
    }
  }

  isMigrationAgency () {
    return this.$store.getters['auth/isMigrationAgency']
  }

  get requiredRule() {
    return (value: string) => !!value || 'Field is required'
  }

  @Watch('value', { immediate: true })
  public valueChanged(val: AgencyUser) {
    this.account = val
  }

  @Watch('account')
  public accountChanged(val: AgencyUser) {
    this.$emit('input', val)
  }

  @Watch('brokerPercentage')
  public brokerPercentageChanged(val: number) {
    this.$emit('broker-percentage', val);
  }

}
